<template>
  <a-modal width="700px" v-model="isShow" title="手动关联" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model ref="formDom" :model="formArticle" :rules="rulesArticle" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
      <a-form-model-item label="文章标题" :label-col="{span: 3}" :wrapper-col="{span: 19}" prop="article">
        <a-select v-model.trim="formArticle.article" mode="multiple" allowClear show-search :show-arrow="false" :filter-option="false" :not-found-content="[]" @search="handleLabelsSelectSearch" @change="handleLabelsSelectChange" placeholder="请输入" :maxTagTextLength="50">
          <a-select-option v-for="item in labelList" :key="item.id" :value="item.id">{{ `${item.title}(${item.org})` }}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提交关联 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { formArticle, rulesArticle } from '../business/filialeList'
import dialog from '@/composables/dialog'
import api from '@/api/'
import store from '@/store/'

export default defineComponent({
  mixins: [dialog],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      topic: _this.$route.params.id,
      line_id: _this.$route.query.line_id,
      rulesArticle,
      btnloading: false,
      labelList: [], // 文章列表
      formArticle: { ...formArticle }
    })

    onMounted(async () => {})
    const methods = {
      // 获取文章
      async getLabelArticle(data = {}) {
        data = Object.assign({}, data, {
          line_id: state.line_id,
          topic: state.topic,
          page: 1,
          per_page: 100
        })
        const res = await api.listArticle(data)
        _this.labelList = res.data.article || []
      },
      handleLabelsSelectSearch(value) {
        if (state.timer) {
          clearTimeout(state.timer)
          state.timer = null
        }
        state.timer = setTimeout(() => {
          _this.getLabelArticle({ title: value })
        }, 500)
      },
      handleLabelsSelectChange(value) {
        if (value.length) {
          this.formArticle.article = value
        } else {
          _this.getLabelArticle()
        }
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.formArticle, topic: state.topic }
          if (valid) {
            if (!_this.isEdit) {
              res = await api.createTopic(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '关联成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查文章标题是否正确')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      }
    }
    return {
      ...toRefs(state),
      ...methods
    }
  }
})
</script>
